import { get, post, put, destroy } from '.';

export function GetAvailableCommunicationProviders(id, options = {}) {
	return get<any>("/app/api/organizations/" + (id || 0).toString() + "/communication_providers", options);
}

export function GetCommunicationCenterOrganization(options = {}) {
	return get<any>("/app/api/communication_center_organization", options);
}

export function GetDeletedOrganizations(options = {}) {
    return get<any>(`/app/api/organizations/deleted`, options);
}

export function GetOrganizationsForSuperAdmin(options = {}) {
	return get<any>("/app/api/organizations/super_admin", options);
}

export function GetOrganizationsForAccessGroups(options = {}) {
	return get<any>("/app/api/organizations/access_groups", options);
}

export function GetFedDncSettingsOrganizations(options = {}) {
	return get<any>(`/app/api/organizations/fed_dnc_settings`, options)
}

export function CreateOrganization(options = {}) {
	return post<any>("/app/api/organizations", options);
}

export function DestroyOrganization(options = {}) {
	return destroy<any>("/app/api/organizations", options);
}

export function FindOrganization(vid: string, options = {}) {
	return get<any>(`/app/api/organizations/${vid}`, options);
}

export function GetOrganizations(options = {}) {
	return get<any>("/app/api/organizations", options);
}

export function UpdateOrganization(vid: string, options = {}) {
	return put<any>(`/app/api/organizations/${vid}`, options);
}

export function RestoreOrganization(id: string) {
  return put<any>(`/app/api/organizations/${id}/restore`);
}

export function SetClosureRedirectForAllAccountOrganizations(accountId: number, enabled: boolean) {
	return put<any>('/app/api/organizations/set_closure_redirect_for_all_account_organizations', {
		account_id: accountId,
		enabled: enabled
	});
}

export function BulkSetAiCommunicationAnalysisEnabledForOrganizations(options = {}) {
	return put<any>('/app/api/organizations/bulk_set_ai_communication_analysis_enabled', options);
}

export function BulkSetPulseAndVoicePrintEnabledForOrganizations(options = {}) {
	return put<any>('/app/api/organizations/bulk_set_pulse_and_voice_print_enabled', options);
}

export function BulkSetVoicePrintEnabledForOrganizations(options = {}) {
	return put<any>('/app/api/organizations/bulk_set_voice_print_enabled', options);
}

export function SearchOrganizationsCrossAccount(options = {}) {
	return get<any>("/app/api/organizations/search", options);
}
